import { createFileRoute } from '@tanstack/react-router';
import { JobListPage } from '@/pages/job/ui/JobListPage';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

/**
 * ジョブ管理一覧ルート
 */
export const Route = createFileRoute('/_protected/job/')({
  component: JobListPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: paginationSchema,
    }),
});
